import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';

export interface DeliveryProps {
  className?: string;
  currency?: 'EUR' | 'GBP';
  deliveryOption: 'Pick-up' | number;
}

function deliveryInfo(
  deliveryOption: 'Pick-up' | number,
  currency: 'EUR' | 'GBP' | undefined,
) {
  switch (deliveryOption) {
    case 'Pick-up':
      return 'Pick-up';
    case 0:
      return 'Free';
    default:
      return currency === 'EUR' ? `€${deliveryOption}` : `£${deliveryOption}`;
  }
}

function Delivery({ deliveryOption, currency, className }: DeliveryProps) {
  return (
    <InfoTitle
      title={deliveryInfo(deliveryOption, currency)}
      listItems={['Delivery']}
      className={className}
      flip={true}
    />
  );
}

export { Delivery };
